module.exports = __webpack_public_path__ + "img/Chevron-down.42590d9c.svg";